
import BaseFormInput from './BaseFormInput';
import Component from 'vue-class-component';

@Component({})
export default class OptionSetFormInput extends BaseFormInput {}
